import { styled } from 'styled-components';

import { bodyMicroText, colors, spacing } from 'theme/theme';

export const SearchImportedHitInfoSourceHolder = styled.div`
  ${bodyMicroText};
  line-height: 1;
  color: ${colors.lightContentGrey};

  &:not(:last-child) {
    margin-bottom: ${spacing[8]};
  }
`;
